// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// You need this import so getAuth is defined
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCRXuxdzklRtr7zegGjMlMY3kkooFTAmAM",
  authDomain: "the33path.firebaseapp.com",
  projectId: "the33path",
  storageBucket: "the33path.firebasestorage.app",
  messagingSenderId: "39153388561",
  appId: "1:39153388561:web:8e2dba553a3efa736975b0",
  measurementId: "G-XK6FXESQLM",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Export modules
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
